var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('v-container',{staticStyle:{"padding":"0"},attrs:{"fluid":""}},[_c('v-card',{staticClass:"elevation-0 hide-overflow d-flex flex-column align-stretch",attrs:{"height":"100vh"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }